import script from "./Call-For-FS.vue?vue&type=script&setup=true&lang=js"
export * from "./Call-For-FS.vue?vue&type=script&setup=true&lang=js"

import "./Call-For-FS.vue?vue&type=style&index=0&id=46a3d512&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a3d512"]])

export default __exports__